export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) {
    if (!globalThis.myCache) {
      globalThis.myCache = {};
    }

    if (!globalThis.myCache.someValue) {
      const data = await $fetch(
        "https://sso-s3.s3.ap-northeast-1.amazonaws.com/crawler-user-agents.json"
      );
      globalThis.myCache.someValue = data;
    }

    const crawlUser = globalThis.myCache.someValue;

    const agent = useRequestHeaders()["user-agent"] || "";
    for (let value of crawlUser) {
      let regex = new RegExp(value.ua, "i");
      if (regex.test(agent)) {
        return;
      }
    }
  }
  if (process.client) {
    const config = useRuntimeConfig();
    if (!config.public.apiURL.includes("admin") && to.query.locale) {
      const lang = to.query.locale === "en" ? "" : `/${to.query.locale}`;
      return navigateTo(lang);
    } else if (
      !config.public.apiURL.includes("admin") &&
      to.query.error !== "company_en_required" &&
      to.query.error !== "expired_terms" &&
      to.query.login !== "none"
    ) {
      return navigateTo(
        `https://${config.public.auth0.domain}/authorize?client_id=${config.public.auth0.clientID}&response_type=code&redirect_uri=${config.public.apiURL}/login/auth0?path=${to.path}&scope=openid%20profile%20email&prompt=none`,
        { external: true }
      );
    }
  }
});
